// ── Firebase (web) initialisation ────────────────────────────────────────────
// Used only on the WEB build so @capacitor-firebase/messaging can obtain an FCM
// token in the browser. Native builds get Firebase from google-services.json /
// GoogleService-Info.plist and don't need this.
//
// Fill these from Firebase Console → Project settings → Your apps → Web app,
// and the VAPID key from Cloud Messaging → Web configuration → Web Push
// certificates. Provide them at build time via REACT_APP_FIREBASE_* env vars
// (see frontend/.env.production).

import { initializeApp, getApps } from 'firebase/app';

export const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

// Web Push certificate key pair (public key) from Firebase Cloud Messaging.
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

export const isFirebaseWebConfigured = () => !!firebaseConfig.apiKey && !!firebaseConfig.projectId;

let _app = null;
export const initFirebaseWeb = () => {
  if (!isFirebaseWebConfigured()) return null;
  if (!_app) _app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  return _app;
};
